import React, { useState, useEffect } from 'react';
import { Modal, Button } from "react-bootstrap";
import Sound from 'react-sound';
import API, { s3base } from 'api.js';
import SelectOption from "components/PracticeMaterial/SelectOption";

import listenAudioImage from "assets/images/images_new/audio-icon.png";
/**
 * Below Array is to show speed option dropdown on popup, if values added in it, dropdown will be visible with added values.
 */
const availablePlaybackRates = [
	// {
	// 	label: `1 x`,
	// 	value: 1
	// },
	// {
	// 	label: `1.2 x`,
	// 	value: 1.2
	// },
	// {
	// 	label: `1.5 x`,
	// 	value: 1.5
	// }
];

export default function ListenAudio(props) {
	let { isOpen, toggle, question, question_id, voices, audios } = props;

	const [selectedVoice, setSelectedVoice] = useState("Select Audio Voice");
	const [audioUrl, setAudioUrl] = useState(null);
	const [lastPlayed, setLastPlayed] = useState(null);
	const [selectedSpeed, setSelectedSpeed] = useState(availablePlaybackRates[0] || null);
	const [speedOptions, setSpeedOptions] = useState(availablePlaybackRates);
	const [audioPlaying, setAudioPlaying] = useState(false);
	const [soundStatus, setSoundStatus] = useState(Sound.status.PLAYING);
	const [availableVoices, setAvailableVoices] = useState([]);

	useEffect(() => {

		filterVoiceList();

	}, []);

	useEffect(() => {
		if (audios?.length > 0) {
			const selected = audios.filter((audio) => {
				return audio.label === selectedVoice;
			});

			if (selected?.length > 0) {
				const audio_url = selected[0].value;
				const full_url = `${s3base}/${audio_url}`;
				
				setAudioUrl(full_url);
				setLastPlayed(full_url);
				setSoundStatus(Sound.status.PLAYING);
			}
		}
	}, [selectedVoice]);

	useEffect(() => {
		if (availableVoices.length > 0) {
			selectDefaultVoice();
		}
	}, [availableVoices]);


	const selectDefaultVoice = () => {
		let x = parseInt(Math.random() * availableVoices.length);
		selectVoice(availableVoices[x].value);
	}


	const filterVoiceList = async () => {
		let filtered_voices = [];
		if (voices.length > audios.length) {
			await audios.map((audio) => {
				filtered_voices.push({
					label: audio.label,
					value: audio.label
				});
			});
			setAvailableVoices(filtered_voices);
		} else {
			setAvailableVoices(voices);
		}
	}

	const selectVoice = (selectedValue) => {
		setSelectedVoice(selectedValue);
		
		/**
		 * Not using this block on code now.
		 * Fetching audios while loading question.
		 *
		setAudioUrl(null);

		API({
			url: 'generate/aiaudio',
			method: 'POST',
			data: {
				voice: selectedValue,
				question_id: question_id
			}
		}).then((res) => {
			const { audio_url } = res.data;
			const full_url = `${s3base}/${audio_url}`;
			setAudioUrl(full_url);
			setLastPlayed(full_url);
			
		}).catch((err) => {
			console.log("error", err);
		});
		*/
	}

	const finishStopped = () => {
		// setAudioUrl("");
		setSoundStatus(Sound.status.STOPPED);
		setAudioPlaying(!audioPlaying);
	}

	const selectSpeed = (speed) => {
		const selected = speedOptions.filter((option) => {
			return option.value === speed;
		});
		setSelectedSpeed(selected[0]);
	}

	const playPauseButton = () => {
		setSoundStatus(audioPlaying ? Sound.status.PAUSED : Sound.status.PLAYING);
		setAudioPlaying(!audioPlaying);
	}

	const audioLoaded = (obj) => {
		if (obj.loaded) {
			setAudioPlaying(true);
			// setSoundStatus(Sound.status.PLAYING);
		}
	}

	const renderPlayPauseButton = () => {
		if (audioUrl === null || audioUrl === "") {
			return "";
		} else {
			return (
				<button className="play-pause-button d-flex gap-2" onClick={playPauseButton}>
				<i className={`fa fa-${audioPlaying ? "pause" : "play"}`} ></i>
				  {audioPlaying ? " PAUSE" : " PLAY"}
				</button>
			);
		}
		return "";
	}

	const popupTitle = () => {
		const { subcategory_id } = props;
		let heading = "";
		switch(parseInt(subcategory_id)) {
			case 1:
				heading = "Sample Response";
				break;
			case 11:
				heading = "Hearing Mode";
				break;
		}

		return heading;
	}

	return (
		<Modal
			show={isOpen}
			centered
			size="lg"
			className="text-translate-modal p-3"
		>
			<Modal.Header className="d-flex">
				<Modal.Title className="text-translation popup_heading m-0 gap-2">
					<div className="modal-header-img">
						<img src={listenAudioImage} alt="multi-languages" />
					</div> {popupTitle()}
				</Modal.Title>

				<Button variant="link" className="modalClose-Btn p-0" onClick={() => toggle(false)}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					width="24"
					height="24"
				>
					<path
					d="M18 6L6 18M6 6l12 12"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
					/>
				</svg>
				</Button>
			</Modal.Header>
			<Modal.Body>
				<div>
					<div className="listen-audio">
						<div className="row m-0 align-items-center">
							<h2 className="translate-title p-0 col-12">AI Voice</h2>
							<div className="col-6 col-sm-6 col-md-4 col-lg-2 p-0">
								{availableVoices.length > 0 &&
									<SelectOption
										isClearable={false}
										selected={selectedVoice}
										data={availableVoices.filter((audio, i) => {
											return audio.value !== selectedVoice
										})}
										changeEvent={selectVoice}
										placeholder={selectedVoice}
										disabled={true}
									/>
								}
							</div>
							{availableVoices.length > 0 && speedOptions.length > 0 &&
								<div className="col-6 col-sm-6 col-md-4 col-lg-2 p-0">
									<SelectOption
			                            isClearable={false}
			                            selected={selectedSpeed?.label}
			                            data={speedOptions.filter((speed, i) => {
			                                return speed?.label !== selectedSpeed?.label
			                            })}
			                            changeEvent={selectSpeed}
			                            placeholder={selectedSpeed?.label}
			                        />
								</div>
							}
							<div className="col-6 col-md-2 p-0 PlayPauseButton-wrapper">
								{renderPlayPauseButton()}
							</div>
						</div>
						<div className="mt-3 mb-2 ques-text">{question}</div>
						<div className="sound-container" style={{ display: 'none'}}>
							{audioUrl !== null &&
								<Sound
									url={audioUrl}
									onLoad={audioLoaded}
									playStatus={soundStatus}
									onFinishedPlaying={finishStopped}
									playbackRate={selectedSpeed?.value}
								/>
							}
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
}